define(
    'utils/tooltip-init',[
        'jquery',

        'modules/tooltip'
    ],
    function ($, Tooltip) {
        return function (root) {
            var t;

            root.find('[data-tooltip]').each(function () {
                t = new Tooltip($(this), $(this).attr('data-tooltip'));

                t.init();
                t.destroy(root, 'domChanged');
            });
        };
    }
);
